// export const environment = {
//     production: false,
//     apiUrl: 'https://localhost:7221'
// };


export const environment = {
    production: true,
    apiUrl: 'https://mobility-001-site13.mtempurl.com'
};